import { FormControl, OutlinedInput, styled, Typography } from '@mui/material';
import { injectTSDI } from '@tools/tsdi';
import { isDev } from '@tools/utils/url';
import { observer } from 'mobx-react';
import * as React from 'react';

import { LoginStore } from '../login-store';

const TenantFieldContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    width: '100%',
    maxWidth: '400px',
    '& .MuiFormControl-root': {
        flexGrow: 1
    },
    '& .MuiOutlinedInput-root': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,

        '& fieldset': {
            borderRightWidth: '0 !important',
            borderColor: `${theme.palette.grey[200]}!important`
        }
    }
}));

const Adornment = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[200],
    height: '100%',
    padding: `0 ${theme.spacing(2)}`,
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px'
}));

const TenantTextField = observer(() => {
    const loginStore = injectTSDI(LoginStore);
    const { returnedTenantName } = loginStore.form.$;
    const { value, error, onChange } = returnedTenantName;

    return (
        <TenantFieldContainer>
            <FormControl variant="outlined" error={!!error} fullWidth>
                <OutlinedInput
                    fullWidth
                    type="text"
                    onChange={(e) => {
                        onChange(e.currentTarget.value);
                    }}
                    value={value}
                    notched={false}
                />
            </FormControl>
            <Adornment>
                <Typography>{`.web${
                    isDev() ? '.dev' : ''
                }.magicline.com`}</Typography>
            </Adornment>
        </TenantFieldContainer>
    );
});

export default TenantTextField;
